(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

// ----------- Native javascript ----------- //
// legacy browser alert
var ua = navigator.userAgent;

if (ua.indexOf("MSIE 6.0") != -1) {
  alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
} else if (ua.indexOf("MSIE 7.0") != -1) {
  alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
} else if (ua.indexOf("MSIE 8.0") != -1) {
  alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
} else if (ua.indexOf("MSIE 9.0") != -1) {
  alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
} else if (ua.indexOf("MSIE 10.0") != -1) {
  alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
} else {} //ピックアップ商品 SPスライダー01


var p_detail_container_s; //swiper 768以下で起動

$(window).on('load resize', function () {
  var w = $(window).width();
  $(document).ready(function () {
    if (w <= 768) {
      if (p_detail_container_s) {
        return;
      } else {
        p_detail_container_s = new Swiper('.p_detail_container_s', {
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            //ナビゲーションのオプション（矢印ボタンの要素を指定）
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        });
      }
    } else {
      if (p_detail_container_s) {
        p_detail_container_s.destroy();
        p_detail_container_s = undefined;
      }
    }
  });
});
$(function () {
  $('.__head_sub').matchHeight();
  $('.__list-text .__head').matchHeight();
}); //サイン対応力スライド

var galleryThumbs_responsiveness_1 = new Swiper('.gallery-responsiveness-single-1', {
  spaceBetween: 0,
  slidesPerView: 3,
  direction: 'vertical',
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true //loop: true

});
var galleryTop_responsiveness_1 = new Swiper('.gallery-top-responsiveness-1', {
  spaceBetween: 0,
  //loop: true,
  direction: 'vertical',
  thumbs: {
    swiper: galleryThumbs_responsiveness_1
  }
});
var galleryThumbs_responsiveness_2 = new Swiper('.gallery-responsiveness-single-2', {
  spaceBetween: 0,
  slidesPerView: 3,
  direction: 'vertical',
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true //loop: true

});
var galleryTop_responsiveness_2 = new Swiper('.gallery-top-responsiveness-2', {
  spaceBetween: 0,
  //loop: true,
  direction: 'vertical',
  thumbs: {
    swiper: galleryThumbs_responsiveness_2
  }
});
var galleryThumbs_responsiveness_2 = new Swiper('.gallery-responsiveness-single-3', {
  spaceBetween: 0,
  slidesPerView: 3,
  direction: 'vertical',
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true //loop: true

});
var galleryTop_responsiveness_2 = new Swiper('.gallery-top-responsiveness-3', {
  spaceBetween: 0,
  //loop: true,
  direction: 'vertical',
  thumbs: {
    swiper: galleryThumbs_responsiveness_2
  }
}); //サイン詳細トップスライド

var galleryThumbs_single_1 = new Swiper('.gallery-thumbs-single-1', {
  direction: 'horizontal',
  slidesPerView: 3,
  breakpoints: {
    767: {
      spaceBetween: 0,
      slidesPerView: 3,
      direction: 'vertical',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true //loop: true

    }
  }
});
var galleryTop_single_1 = new Swiper('.gallery-top-single-1', {
  direction: 'horizontal',
  breakpoints: {
    767: {
      spaceBetween: 0,
      //loop: true,
      direction: 'vertical'
    }
  },
  thumbs: {
    swiper: galleryThumbs_single_1
  }
}); //サイン詳細シーン別スライド

var galleryThumbs_single_2_1 = new Swiper('.gallery-thumbs-single-2-1', {
  spaceBetween: 0,
  slidesPerView: 3,
  direction: 'vertical',
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true //loop: true

});
var galleryTop_single_2_1 = new Swiper('.gallery-top-single-2-1', {
  spaceBetween: 0,
  //loop: true,
  direction: 'vertical',
  thumbs: {
    swiper: galleryThumbs_single_2_1
  }
}); //サイン詳細シーン別スライド

var galleryThumbs_single_2_2 = new Swiper('.gallery-thumbs-single-2-2', {
  spaceBetween: 0,
  slidesPerView: 3,
  direction: 'vertical',
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true //loop: true

});
var galleryTop_single_2_2 = new Swiper('.gallery-top-single-2-2', {
  spaceBetween: 0,
  //loop: true,
  direction: 'vertical',
  thumbs: {
    swiper: galleryThumbs_single_2_2
  }
}); //サイン詳細シーン別スライド

var galleryThumbs_single_2_3 = new Swiper('.gallery-thumbs-single-2-3', {
  spaceBetween: 0,
  slidesPerView: 3,
  direction: 'vertical',
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true //loop: true

});
var galleryTop_single_2_3 = new Swiper('.gallery-top-single-2-3', {
  spaceBetween: 0,
  //loop: true,
  direction: 'vertical',
  thumbs: {
    swiper: galleryThumbs_single_2_3
  }
}); //サイン詳細シーン別スライド

var galleryThumbs_single_2_4 = new Swiper('.gallery-thumbs-single-2-4', {
  spaceBetween: 0,
  slidesPerView: 3,
  direction: 'vertical',
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true //loop: true

});
var galleryTop_single_2_4 = new Swiper('.gallery-top-single-2-4', {
  spaceBetween: 0,
  //loop: true,
  direction: 'vertical',
  thumbs: {
    swiper: galleryThumbs_single_2_4
  }
}); //サイン詳細シーン別スライド

var galleryThumbs_single_2_5 = new Swiper('.gallery-thumbs-single-2-5', {
  spaceBetween: 0,
  slidesPerView: 3,
  direction: 'vertical',
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true //loop: true

});
var galleryTop_single_2_5 = new Swiper('.gallery-top-single-2-5', {
  spaceBetween: 0,
  //loop: true,
  direction: 'vertical',
  thumbs: {
    swiper: galleryThumbs_single_2_5
  }
}); //サイン詳細シーン別スライド

var galleryThumbs_single_2_6 = new Swiper('.gallery-thumbs-single-2-6', {
  spaceBetween: 0,
  slidesPerView: 3,
  direction: 'vertical',
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true //loop: true

});
var galleryTop_single_2_6 = new Swiper('.gallery-top-single-2-6', {
  spaceBetween: 0,
  //loop: true,
  direction: 'vertical',
  thumbs: {
    swiper: galleryThumbs_single_2_6
  }
}); //ページ内リンクスムーススクロール

$(function () {
  var headerHight = 0; //ヘッダの高さ
  // #で始まるアンカーをクリックした場合に処理

  $('a[href^="#"]').click(function () {
    // スクロールの速度
    var speed = 800; // ミリ秒
    // アンカーの値取得

    var href = $(this).attr("href"); // 移動先を取得

    var target = $(href == "#" || href == "" ? "html" : href); // 移動先を数値で取得

    var position = target.offset().top - headerHight; //ヘッダの高さ分位置をずらす
    // スムーススクロール

    $("body,html").animate({
      scrollTop: position
    }, speed, "swing");
    return false;
  });
});
$(function () {
  // アニメーション
  var EffectH = 100;
  $(window).on("scroll load", function () {
    var scTop = $(this).scrollTop();
    var scBottom = scTop + $(this).height();
    var effectPos = scBottom - EffectH;
    $(".js-scroll").each(function () {
      var thisPos = $(this).offset().top;

      if (thisPos < effectPos) {
        // .js-scrollという要素が可視範囲に入ったら
        $.when( // .js-scrollにshowというclassを付与
        $(this).addClass("show")).done(function () {
          //  その後、0.5秒遅らせて.js-scrollにdoneというclassを付与
          $(this).delay(500).queue(function () {
            $(this).addClass("done");
          });
        });
      }
    });
  });
}); //ハンバーガメニュー

jQuery(function ($) {
  $(function () {
    var $header = jQuery("#header"); // Nav Toggle Button

    jQuery("#nav_toggle").click(function () {
      $header.toggleClass("open");
    });
    jQuery("nav a").on("click", function () {
      if (window.innerWidth <= 768) {
        $header.removeClass("open");
      }
    });
  });
}); //メインスライダー

(function ($) {
  function setimage() {
    // 設定
    var height = $(window).height(); // 高さ

    var width = $(window).width(); // 幅

    var win_ratio = width / height;
    $(".Opening").css({
      height: height
    });
    $(".Opening ul li").css({
      height: height
    });

    if (win_ratio > 1.5) {
      //画像の比率が大きかったら
      $(".Opening ul li img.Opening__img").css({
        width: "100%",
        height: "auto",
        "margin-left": 0
      });
      var winwidth = $(".Opening").width();
      var imgheight = winwidth * 0.66;
      var winheight = $(".Opening").height();
      var imgtopmargin = (imgheight - winheight) / 2;
      $(".Opening ul li img.Opening__img").css({
        "margin-top": -imgtopmargin
      });
    } else if (win_ratio < 1.5) {
      //画像の比率が小さかったら
      var imgwidth = height / 800 * 1200;
      var winwidth = $(".Opening").width();
      var imgmargin = (winwidth - imgwidth) / 2;
      $(".Opening ul li img.Opening__img").css({
        width: imgwidth,
        height: height,
        "margin-left": imgmargin,
        "margin-top": 0
      });
    }
  } //slide


  $(function () {
    setimage();
    var interval = 4000; // 切り替わりの間隔（ミリ秒）

    var fade_speed = 2000; // フェード処理の早さ（ミリ秒）

    $(".Opening ul li").hide().css({
      position: "absolute",
      top: 0,
      left: 0
    });
    $(".Opening ul li:first").addClass("active").show();
    $(".Opening ul li:first img.Opening__img").animate({
      paddingRight: 0.1
    }, {
      duration: 5000,
      step: function step(now, fx) {
        $(this).css({
          transform: "scale(" + (1 + now) + ")"
        });
      },
      complete: function complete() {
        $(".Opening ul li img.Opening__img").css("paddingRight", 0);
      }
    });
    setInterval(function () {
      var $active = $(".Opening ul li.active");
      var $activeafter = $(".Opening ul li.active:after");
      var $next = $active.next("li").length ? $active.next("li") : $(".Opening ul li:first"); //$active.fadeOut(fade_speed,function(){$active.removeClass("active");});

      $active.fadeOut(fade_speed);
      $active.removeClass("active");
      $next.fadeIn(fade_speed).addClass("active");
      $(".Opening ul li.active img.Opening__img").animate({
        paddingRight: 0.1
      }, {
        duration: 5000,
        step: function step(now, fx) {
          $(this).css({
            transform: "scale(" + (1 + now) + ")"
          });
        },
        complete: function complete() {
          $(".Opening ul li img.Opening__img").css("paddingRight", 0);
        }
      });
    }, interval);
  }); //resi

  var timer = false;
  $(window).resize(function () {
    if (timer !== false) {
      clearTimeout(timer);
    }

    timer = setTimeout(function () {
      setimage();
    }, 200);
  });
})(jQuery); //ハンバーガメニュー


(function ($) {
  $(function () {
    var $header = $("#header-ls"); // Nav Toggle Button

    $("#nav_toggle").click(function () {
      $header.toggleClass("open");
    });
    $("nav a").on("click", function () {
      if (window.innerWidth <= 768) {
        $header.removeClass("open");
      }
    });
  });
})(jQuery); // ---------------------------------G&E TOPページ実績スライダー


var swiper = new Swiper('#limitedSwiper01', {
  slidesPerView: 3,
  spaceBetween: 0,
  loop: true,
  speed: 2000,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false
  }
});
var swiper = new Swiper('#limitedSwiper02', {
  slidesPerView: 3,
  spaceBetween: 0,
  loop: true,
  speed: 2000,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false // reverseDirection: true,

  }
}); //G&E TOPページection01-01

var section01_01_slider_thumbs = new Swiper('#section01_01_slider-thumbs', {
  slidesPerView: 3,
  breakpoints: {
    767: {
      slidesPerView: 3,
      spaceBetween: 2,
      direction: 'horizontal',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true
    }
  }
});
var section01_01_slider = new Swiper('#section01_01_slider', {
  spaceBetween: 0,
  thumbs: {
    swiper: section01_01_slider_thumbs
  },
  breakpoints: {
    767: {
      spaceBetween: 2,
      direction: 'horizontal',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true
    }
  }
}); //G&E TOPページection01-02

var section01_02_slider_thumbs = new Swiper('#section01_02_slider-thumbs', {
  slidesPerView: 3,
  breakpoints: {
    767: {
      slidesPerView: 3,
      spaceBetween: 2,
      direction: 'horizontal',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true
    }
  }
});
var section01_02_slider = new Swiper('#section01_02_slider', {
  spaceBetween: 0,
  thumbs: {
    swiper: section01_02_slider_thumbs
  },
  breakpoints: {
    767: {
      spaceBetween: 2,
      direction: 'horizontal',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true
    }
  }
}); //G&E TOPページection01-03

var section01_03_slider_thumbs = new Swiper('#section01_03_slider-thumbs', {
  slidesPerView: 3,
  breakpoints: {
    767: {
      slidesPerView: 3,
      spaceBetween: 2,
      direction: 'horizontal',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true
    }
  }
});
var section01_03_slider = new Swiper('#section01_03_slider', {
  spaceBetween: 0,
  thumbs: {
    swiper: section01_03_slider_thumbs
  },
  breakpoints: {
    767: {
      spaceBetween: 2,
      direction: 'horizontal',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true
    }
  }
}); //G&E TOPページection01-04

var section01_04_slider_thumbs = new Swiper('#section01_04_slider-thumbs', {
  slidesPerView: 3,
  breakpoints: {
    767: {
      slidesPerView: 3,
      spaceBetween: 2,
      direction: 'horizontal',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true
    }
  }
});
var section01_04_slider = new Swiper('#section01_04_slider', {
  spaceBetween: 0,
  thumbs: {
    swiper: section01_04_slider_thumbs
  },
  breakpoints: {
    767: {
      spaceBetween: 2,
      direction: 'horizontal',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true
    }
  }
}); //G&E TOPページection01-05

var section01_05_slider_thumbs = new Swiper('#section01_05_slider-thumbs', {
  slidesPerView: 3,
  breakpoints: {
    767: {
      slidesPerView: 3,
      spaceBetween: 2,
      direction: 'horizontal',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true
    }
  }
});
var section01_05_slider = new Swiper('#section01_05_slider', {
  spaceBetween: 0,
  thumbs: {
    swiper: section01_05_slider_thumbs
  },
  breakpoints: {
    767: {
      spaceBetween: 2,
      direction: 'horizontal',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true
    }
  }
}); //G&E TOP ラインナップスライダー

$(document).ready(function () {
  var top_lineup_slider = new Swiper('#top_lineup_slider', {
    slidesPerView: 1,
    autoplay: {
      delay: 3000
    },
    loop: true
  });
  $('input[name="tab_item"]').change(function () {
    slider.slick('setPosition');
  });
}); //ローボルトシステム　メリットスライダー

var ge_lowvoltsystem_merit_thumbs = new Swiper('#ge-lowvoltsystem-merit-thumbs', {
  slidesPerView: 1,
  breakpoints: {
    767: {
      slidesPerView: 1,
      spaceBetween: 0,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true
    }
  }
});
var ge_lowvoltsystem_merit = new Swiper('#ge-lowvoltsystem-merit', {
  thumbs: {
    swiper: ge_lowvoltsystem_merit_thumbs
  },
  pagination: {
    el: '#swiper-pagination01',
    type: 'fraction'
  },
  navigation: {
    nextEl: '#swiper-button-next01',
    prevEl: '#swiper-button-prev01'
  }
}); //エバーアート 商品スライダー

var ge_everartlight_01 = new Swiper('#ge-everartlight-01', {
  pagination: {
    el: '#swiper-pagination01',
    type: 'fraction'
  },
  navigation: {
    nextEl: '#swiper-button-next01',
    prevEl: '#swiper-button-prev01'
  }
});
var ge_everartlight_02 = new Swiper('#ge-everartlight-02', {
  pagination: {
    el: '#swiper-pagination02',
    type: 'fraction'
  },
  navigation: {
    nextEl: '#swiper-button-next02',
    prevEl: '#swiper-button-prev02'
  }
});
var ge_everartlight_03 = new Swiper('#ge-everartlight-03', {
  pagination: {
    el: '#swiper-pagination03',
    type: 'fraction'
  },
  navigation: {
    nextEl: '#swiper-button-next03',
    prevEl: '#swiper-button-prev03'
  }
});
var ge_everartlight_04 = new Swiper('#ge-everartlight-04', {
  pagination: {
    el: '#swiper-pagination04',
    type: 'fraction'
  },
  navigation: {
    nextEl: '#swiper-button-next04',
    prevEl: '#swiper-button-prev04'
  }
}); //エバーアート 商品スライダー

var ge_everartlight_01 = new Swiper('#ge-normalslide-00', {
  pagination: {
    el: '#swiper-pagination01',
    type: 'fraction'
  },
  navigation: {
    nextEl: '#swiper-button-next01',
    prevEl: '#swiper-button-prev01'
  }
});
var normal_slider = new Swiper('#normal_slider', {
  autoplay: {
    delay: 3000
  },
  loop: true,
  effect: 'fade',
  speed: 2000
}); //カーポートライト特徴SP用スライド

var carport_sp_slider1 = new Swiper('#carport_sp_slider1', {
  slidesPerView: 1,
  autoplay: false,
  loop: false,
  navigation: {
    //ナビゲーションのオプション（矢印ボタンの要素を指定）
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
}); //カーポートライト特徴SP用スライド

var carport_sp_slider2 = new Swiper('#carport_sp_slider2', {
  slidesPerView: 1,
  autoplay: false,
  loop: false,
  navigation: {
    //ナビゲーションのオプション（矢印ボタンの要素を指定）
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
}); //カーポートライト特徴SP用スライド

var carport_sp_slider3 = new Swiper('#carport_sp_slider3', {
  slidesPerView: 1,
  autoplay: false,
  loop: false,
  navigation: {
    //ナビゲーションのオプション（矢印ボタンの要素を指定）
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
}); //GEメインビジュアル

setTimeout(function () {
  var lighting = new Swiper('#lightingMvSlider', {
    loop: true,
    effect: 'fade',
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    speed: 2000,
    on: {
      autoplayStart: function autoplayStart() {
        setTimeout(function () {
          var sampleElement = document.getElementById('o-mainvisual-catch');
          sampleElement.classList.add('mv-text-effect');
        }, 500);
      }
    }
  });
}, 1000);

},{}]},{},[1]);
